/* Formularios de cotización (Proyectos, Empresas, Distribuidores, Licitaciones).
   - Sin data-endpoint: envío nativo del formulario de contacto de Shopify.
   - Con data-endpoint (App Proxy "/apps/formularios" de la app Urdile):
       1. /subir  → URLs firmadas; el navegador sube cada archivo directo a Shopify
       2. /enviar → la app guarda archivos + solicitud en el admin y devuelve los links
       3. Los links se agregan al formulario de contacto nativo, que manda el correo.
     Si algo falla, igual se envía el formulario nativo (sin perder la solicitud). */
(function () {
  var MAX_BYTES = 20 * 1024 * 1024;
  var MAX_FILES = 10;

  function fmt(bytes) { return bytes > 1048576 ? (bytes / 1048576).toFixed(1) + ' MB' : Math.ceil(bytes / 1024) + ' KB'; }

  // Botones que preseleccionan el motivo del formulario: <a href="#formulario" data-set-motivo="...">
  function applyMotivo(value) {
    if (!value) return;
    document.querySelectorAll('input[data-motivo]').forEach(function (r) {
      if (r.value === value) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
    });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-set-motivo]');
    if (a) applyMotivo(a.getAttribute('data-set-motivo'));
  });
  var qm = new URLSearchParams(location.search).get('motivo');
  if (qm) applyMotivo(qm);

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) throw new Error(j.error || ('HTTP ' + r.status));
        return j;
      });
    });
  }

  function subirArchivo(destino, file) {
    var fd = new FormData();
    destino.parameters.forEach(function (p) { fd.append(p.name, p.value); });
    fd.append('file', file);
    return fetch(destino.url, { method: 'POST', body: fd }).then(function (r) {
      if (!r.ok) throw new Error('No se pudo subir ' + file.name);
      return { resourceUrl: destino.resourceUrl, nombre: file.name };
    });
  }

  document.querySelectorAll('form[data-urdile-form]').forEach(function (form) {
    var endpoint = (form.getAttribute('data-endpoint') || '').replace(/\/$/, '');
    var fileInput = form.querySelector('input[type="file"]');
    var list = form.querySelector('[data-file-list]');
    var btn = form.querySelector('button[type="submit"]');
    var enviando = false;
    var listoNativo = false;

    if (fileInput && list) {
      fileInput.addEventListener('change', function () {
        list.innerHTML = '';
        var msg = '';
        if (fileInput.files.length > MAX_FILES) msg = 'Puedes adjuntar hasta ' + MAX_FILES + ' archivos.';
        Array.prototype.forEach.call(fileInput.files, function (f) {
          if (f.size > MAX_BYTES) msg = '"' + f.name + '" supera 20 MB. Envíalo por correo.';
          var li = document.createElement('li');
          li.textContent = f.name;
          var sz = document.createElement('span');
          sz.textContent = fmt(f.size);
          li.appendChild(sz);
          list.appendChild(li);
        });
        fileInput.setCustomValidity(msg);
        fileInput.reportValidity();
      });
    }

    // Resalta la zona de archivos al arrastrar encima
    var zona = form.querySelector('.b2b-dropzone');
    if (zona) {
      ['dragenter', 'dragover'].forEach(function (t) { zona.addEventListener(t, function () { zona.classList.add('is-dragover'); }); });
      ['dragleave', 'drop'].forEach(function (t) { zona.addEventListener(t, function () { zona.classList.remove('is-dragover'); }); });
    }

    function estado(texto) { if (btn) btn.innerHTML = texto; }

    // Envío nativo del formulario de contacto de Shopify (manda el correo)
    function enviarNativo(adjuntosTexto) {
      if (adjuntosTexto) {
        var h = form.querySelector('input[name="contact[Adjuntos]"]');
        if (!h) { h = document.createElement('input'); h.type = 'hidden'; h.name = 'contact[Adjuntos]'; form.appendChild(h); }
        h.value = adjuntosTexto;
      }
      if (fileInput) fileInput.disabled = true; // los archivos ya no viajan por aquí
      // requestSubmit dispara el evento submit: el script de Shopify lo necesita
      // para generar el token del CAPTCHA invisible del formulario de contacto
      listoNativo = true;
      if (btn) btn.disabled = false;
      if (form.requestSubmit) form.requestSubmit(btn || undefined);
      else HTMLFormElement.prototype.submit.call(form);
    }

    // Se escucha en fase de captura sobre window para correr ANTES que el hCaptcha
    // de Shopify (que también escucha submit y, si no, enviaría sin los archivos).
    // Al terminar, requestSubmit vuelve a disparar submit y ahí Shopify hace lo suyo.
    window.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      if (!endpoint || listoNativo) return; // envío nativo (y CAPTCHA) a cargo de Shopify
      e.preventDefault();
      e.stopImmediatePropagation();
      if (enviando) return;
      enviando = true;
      if (btn) { btn.disabled = true; btn.dataset.label = btn.innerHTML; }

      var files = fileInput && !fileInput.disabled ? Array.prototype.slice.call(fileInput.files) : [];
      var datos = {};
      new FormData(form).forEach(function (v, k) {
        if (typeof v !== 'string') return;
        var m = k.match(/^contact\[(.+)\]$/);
        if (m) datos[m[1]] = v;
      });

      var paso = files.length
        ? (estado('Preparando archivos…'),
           postJSON(endpoint + '/subir', {
             archivos: files.map(function (f) { return { nombre: f.name, tipo: f.type, tamano: f.size }; })
           }).then(function (r) {
             var hechos = 0;
             estado('Subiendo archivos (0 de ' + files.length + ')…');
             return Promise.all(files.map(function (f, i) {
               return subirArchivo(r.destinos[i], f).then(function (x) {
                 hechos++; estado('Subiendo archivos (' + hechos + ' de ' + files.length + ')…');
                 return x;
               });
             }));
           }))
        : Promise.resolve([]);

      paso
        .then(function (subidos) {
          estado('Enviando solicitud…');
          return postJSON(endpoint + '/enviar', { datos: datos, archivos: subidos, pagina: location.href });
        })
        .then(function (r) {
          var lineas = (r.archivos || []).map(function (a) { return a.nombre + ': ' + (a.url || 'ver en Shopify → Contenido → Archivos'); });
          enviarNativo(lineas.join('\n'));
        })
        .catch(function (err) {
          // No se pierde la solicitud: se envía igual, avisando qué archivos no llegaron
          var nombres = files.map(function (f) { return f.name; }).join(', ');
          enviarNativo(nombres ? 'NO SE PUDIERON SUBIR (' + (err && err.message) + '): ' + nombres + '. Pedirlos al cliente por correo.' : '');
        });
    }, true);
  });
})();
